
import * as alertUtils from '@/utils/alert';


export const validarCamposObrigatorios = (json, arrayValidacoes) => {
  for (let i = 0; i < arrayValidacoes.length; i += 2) {
    const campo = arrayValidacoes[i];
    const mensagemErro = arrayValidacoes[i + 1];

    const erro = validarCampoNoObjeto(json, campo, mensagemErro);
    if (erro) {
      return true;
    }
  }
  return false;
};

export const validarCampoNoObjeto = (obj, campo, mensagemErro) => {
  const valor = obj[campo];
  return validarValorCampo(valor, mensagemErro);
};

export const validarValorCampo = (valor, mensagemErro) => {
  if (valor === undefined || valor === null || valor.toString().trim() === '') {
    alertUtils.alertError('Favor preencher o '+ mensagemErro +', esse campo é obrigatório!', 'Fechar');
    return true;
  }
  return false;
};

export const obterCamposObrigatoriosPadraoParametro = () => {
  return [
    'entrada', 'combo "campo" do novo parametro',
    'tipo', 'campo "tipo" do novo parametro',
    'nome', 'campo "nome" do novo parametro',
    'obrigatorio', 'campo "obrigatorio" do novo parametro',
    'formato', 'campo "formato" do novo parametro',
    'lista', 'campo "lista" do novo parametro',
    'descricao', 'campo "descrição" do novo parametro'
  ];
}



